import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import TextField from "@mui/material/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import Capnhatdangkiemvien from "components/Thongke/Dangkiem/Capnhatdangkiemvien.js";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
const useStyles = makeStyles(styles);
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const dkcolumn = [
  { field: "id", headerName: "ID", width: 50, hide: true },
  {
    field: "ten",
    headerName: "Họ và tên",
    width: 280,
    headerAlign: "center",
  },
  {
    field: "cccd",
    headerName: "Số CCCD",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "trinhdocm",
    headerName: "Trình độ chuyên môn cao nhất",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "trungtamdangkiem",
    headerName: "Đơn vị công tác",
    width: 350,
    headerAlign: "center",
  },
];
export default function Dangkiemvien() {
  const classes = useStyles();
  const [trungtam, setTrungtam] = React.useState([]);
  const [dangkiemvien, setDangkiemvien] = React.useState([]);
  const [dangkiemvienid, setDangkiemvienid] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(50);
  const [opensua, setOpensua] = React.useState(false);
  const handleClosesua = () => {
    setOpensua(false);
    getdangkiemvien();
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  const getttdangkiem = () => {
    var url =
      Config.backend + "/api/Donvi/gettrungtamdangkiemall?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTrungtam(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getdangkiemvien = (trungtam_id) => {
    var url =
      Config.backend +
      "/api/DangKiemVien/getdangkiemvientheodvql?trungtamdangkiem_id=" +
      trungtam_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setDangkiemvien(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  React.useEffect(() => {
    getttdangkiem();
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "32%" }}>
          <Autocomplete
            freeSolo
            disableClearable
            size="small"
            options={trungtam}
            getOptionLabel={(option) => option.ten}
            onChange={(event, value) => {
              getdangkiemvien(value.id);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Chọn trung tâm"
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                  style: {
                    height: "32px",
                    paddingTop: "initial",
                  },
                }}
              />
            )}
          />
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 10 }}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.id}
            rows={dangkiemvien}
            columns={dkcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            onRowClick={(params) => {
              setDangkiemvienid(params.row.id);
            }}
            onCellDoubleClick={(params, event) => {
              if (!event.ctrlKey) {
                setOpensua(true);
              }
            }}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={opensua}
          onClose={handleClosesua}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={8}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Thông tin đăng kiểm viên
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClosesua} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Capnhatdangkiemvien dangkiemvienid={dangkiemvienid} />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
    </GridContainer>
  );
}
